export default {
  props: {
    items: {
      type: Array,
      required: true,
    },
    lightBoxId: {
      type: String,
      required: true,
    },
    loop: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      i18n: {
        backgroundVideo: {
          play: this.$t('Accessibility.videoPlay'),
          pause: this.$t('Accessibility.videoPause'),
        },
        close: {
          label: this.$t('Button.close'),
        },
        navPrev: {
          label: this.$t('Button.previousSlide'),
        },
        navNext: {
          label: this.$t('Button.nextSlide'),
        },
        zoom: {
          in: this.$t('Accessibility.zoomForward'),
          out: this.$t('Accessibility.zoomBackwards'),
        },
        tooltip: {
          label: this.$t('Accessibility.displayCaptionOrCopyright'),
        },
      },
    };
  },
};
